import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatutNettoyage } from 'src/api/models';

@Component({
  selector: 'app-nettoyage-statut',
  templateUrl: './nettoyage-statut.component.html',
  styleUrls: ['./nettoyage-statut.component.css']
})
export class NettoyageStatutComponent implements OnInit {

  @Input('id') public id: number;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  GetNettoyageStatut(s: StatutNettoyage) {
    if (s === undefined) {
      return '';
    } else {
      return this.translateService.instant('Entretien.Nettoyage.Statuts.' + StatutNettoyage[s]);
    }
  } 
}
